import { SingleNews } from '@api/api/news';
import { Drawer } from '@design/components/drawer/Drawer';
import { useDisableScroll } from '@helpers/hooks/use-disable-scroll/useDisableScroll';
import { NewsBadges } from '@terminal/components/news-badges/NewsBadges';
import { PosthogTrackingSource } from '@terminal/services/tracking/posthog/constants';
import styles from './ArticleDrawer.module.scss';
import { ArticleDrawerContent } from './ArticleDrawerContent';
import { useSingleNews } from './hooks/use-single-news/useSingleNews';

export interface ArticleDrawerProps {
  list?: SingleNews[];
  newsId: string;
  source: PosthogTrackingSource;
  onClick?: (singleNews: SingleNews) => void;
  onClose: () => void;
  disableFooter?: boolean;
}

export const ArticleDrawer = ({
  list = [],
  newsId,
  source,
  onClick,
  onClose,
  disableFooter = false,
}: ArticleDrawerProps) => {
  useDisableScroll();

  const initialNews = list.find(item => item.id === newsId);
  const { data, isError, isFetching } = useSingleNews(newsId, initialNews);

  return (
    <Drawer
      isOpen
      className={styles.drawer}
      data-testid="article-drawer"
      handleCloseClick={onClose}
      headerButton={
        data && (
          <NewsBadges highlights={data.highlights} entityTags={data.entities} />
        )
      }
    >
      <ArticleDrawerContent
        isError={isError}
        isFetching={isFetching}
        data={data}
        list={list}
        onArticleClick={onClick}
        onClose={onClose}
        newsId={newsId}
        source={source}
        disableFooter={disableFooter}
      />
    </Drawer>
  );
};
